// Raw auth API calls; consumed by the AuthProvider and AuthPage.
import { http } from "../http";

export const login = (email, password) =>
  http.post(`/login`, { email, password }).then((r) => r.data);

export const register = (email, password) =>
  http.post(`/register`, { email, password }).then((r) => r.data);

/** One-door flow: does this email already have an account? */
export const lookupEmail = (email) =>
  http.post(`/auth/lookup`, { email }).then((r) => r.data);
